import { createContext, useContext } from "react"

const DiscardFormStateContext = createContext()

export const useDiscardFormStateContext = () =>
  useContext(DiscardFormStateContext)

export default DiscardFormStateContext
